module.exports = __webpack_public_path__ + "static/media/sunbeam-hero-bg.1eb2e363.jpg";